import * as t from 'io-ts';
import {PickByValueExact} from 'utility-types';

import {StashValues} from '../stashModel';
import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

export const RStashBooleanValueBase = t.intersection([
  RLastWriterWinsValue,
  t.type({
    isEnabled: t.boolean,
  }),
]);

export const defaultBooleanValue: StashBooleanValue = {
  ...defaultLastWriterWinsValue,
  isEnabled: false,
};

export type StashBooleanValue = t.TypeOf<typeof RStashBooleanValueBase>;
export type StashBooleanKeys = keyof PickByValueExact<StashValues, StashBooleanValue>;

/*
 * Conflict resolution.
 */

export const mergeStashBooleanValue: (
  left: StashBooleanValue,
  right: StashBooleanValue,
) => StashBooleanValue = mergeLastWriterWinsValue;
